import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, useMediaQuery, useTheme as useMuiTheme } from '@mui/material';
import AdminSidebar from '../components/admin/AdminSidebar';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const AdminLayout = () => {
    const { logout, currentUser } = useAuth();
  const { theme } = useTheme();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  useEffect(() => {
    setSidebarOpen(!isMobile);
  }, [isMobile]);

  return (
    <Box
      data-theme={theme}
      sx={{
        display: 'flex',
        minHeight: '100vh',
        bgcolor: theme === 'dark' ? '#121212' : '#f5f7fa',
        color: theme === 'dark' ? '#f5f5f5' : '#333',
        fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, sans-serif',
      }}
    >
           <AdminSidebar
        logout={logout}
        isOpen={sidebarOpen}
        isMobile={isMobile}
        onSidebarToggle={setSidebarOpen}
        currentUser={currentUser}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,                    // ✅ Take remaining space
          minWidth: 0,                    // ✅ Prevent flex overflow
          minHeight: '100vh',
          bgcolor: theme === 'dark' ? '#1a1a1a' : '#ffffff',
          transition: (t) =>
            t.transitions.create(['margin', 'width'], {
              easing: t.transitions.easing.sharp,
              duration: t.transitions.duration.leavingScreen,
            }),
          boxSizing: 'border-box',
          p: {
            xs: '72px 16px 16px',
            md: 3,
          },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default AdminLayout;